// src/Components/PaymentFailure/PaymentFailure.jsx
import React from 'react';
import './PaymentFailure.css'; // Import the CSS file

const PaymentFailure = () => {
  return (
    <div className="payment-failure-container">
      <div className="failure-icon">
        <svg 
          width="64" 
          height="64" 
          fill="none" 
          stroke="currentColor" 
          strokeWidth="4" 
          strokeLinecap="round" 
          strokeLinejoin="round"
        >
          <circle cx="32" cy="32" r="30" />
          <path d="M20 20l24 24M44 20L20 44" />
        </svg>
      </div>
      <h1>Payment Unsuccessful</h1>
      <p>Sorry, there was a problem processing your payment. Please try again or contact support if the issue persists.</p>
      <p>If you have any questions, <a href="mailto:soyeon@bluedovecreation.com">reach out to our support team.</a></p>
      <div className="failure-actions">
        <a href="/">Go back to Home</a>
      </div>
    </div>
  );
};

export default PaymentFailure;
